import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import catalogos from './modules/catalogos';
//import catalogoDos from './modules/catalogoDos';

export default new Vuex.Store({
    state: {
        cargando: true,
    },
    mutations:{
        setearCargando(state, nuevoState){
            state.cargando = nuevoState;
        },
    },
    modules:{
        catalogos
    }
});